var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFavoriteFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.146 3.038a9.72 9.72 0 013.977-1.035 8.56 8.56 0 016.7 3 9.55 9.55 0 011.89 7.79c-.61 3.51-4.79 8.54-12.43 14.99-.99.82-1.92 1.56-2.7 2.19a1.05 1.05 0 01-.62.21 1 1 0 01-.62-.21c-.79-.61-1.71-1.36-2.71-2.18-7.65-6.46-11.83-11.49-12.44-15a9.56 9.56 0 011.83-7.79 8.59 8.59 0 016.76-3 9.72 9.72 0 017.17 3.62 9.72 9.72 0 013.193-2.585z"
  })));
}

export default SvgFavoriteFill;